import { CheckIcon } from "lucide-react";

import {
  applyFitTextToControl,
  isFitTextEnabled,
  setFitTextEnabled
} from "@/helpers/editor/command-style";

import { ContextMenuItem } from "@/components/ui/context-menu";

type Props = {
  rightClickedElement: HTMLElement;
  label?: string;
};

const FitTextControl: React.FC<Props> = ({
  rightClickedElement,
  label = "تغییر اندازه با متن"
}) => {
  const isFitText = isFitTextEnabled(rightClickedElement);

  const handleToggle = () => {
    const nextValue = !isFitText;
    setFitTextEnabled(rightClickedElement, nextValue);

    if (nextValue) {
      applyFitTextToControl(rightClickedElement);
    }
  };

  return (
    <ContextMenuItem
      className="flex items-center justify-between"
      onClick={handleToggle}
    >
      {label}
      {isFitText && <CheckIcon size={16} className="text-primary" />}
    </ContextMenuItem>
  );
};

export default FitTextControl;
